import { MetricUnit } from '@/__generated__/graphql';
import { useFormatters } from '@/hooks/useFormatters';
import { theme } from '@/theme';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { type FC } from 'react';

interface Props {
  defaultValue: number;
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number | undefined;
  error: string;
}

export const PositionSlider: FC<Props> = ({ value, defaultValue, onChange, min, max, error }) => {
  const { formatMetricValue } = useFormatters();
  const color = error ? theme.palette.error.dark : value === defaultValue ? 'white' : '#26A69A';

  return (
    <Box mt={3}>
      <Slider
        valueLabelDisplay="off"
        defaultValue={defaultValue}
        value={value}
        onChange={(_, value) => {
          if (typeof value === 'number') onChange(value);
        }}
        min={min}
        max={max}
        sx={{
          color,
          height: 12,
          '& .MuiSlider-track': {
            border: 'none',
          },
          '& .MuiSlider-thumb': {
            height: 24,
            width: 24,
            backgroundColor: '#3D4855',
            border: '3px solid currentColor',
            '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
              boxShadow: 'inherit',
            },
            '&::before': {
              display: 'none',
            },
          },
        }}
      />
      <Box display="flex" justifyContent="space-between" mt={-1}>
        <Typography>
          {formatMetricValue(min, { unit: MetricUnit.Centimeter, precision: 0 })}
        </Typography>
        {max && (
          <Typography>
            {formatMetricValue(max, { unit: MetricUnit.Centimeter, precision: 0 })}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
